import { useSite } from "@/context/SiteContext";
import { useProducts } from "@/context/ProductsContext";

export default function About() {
  const { settings, loading: siteLoading } = useSite();
  const { categories, loading: productsLoading } = useProducts();
  const liveImages = [
    categories.find(c => c.slug === "lehengas")?.image || settings.home.editorial.image,
    categories.find(c => c.slug === "bridal-couture")?.image || settings.home.bridal.image,
    categories.find(c => c.slug === "gowns")?.image || settings.home.editorial.image,
  ];
  return (
    <div className="pt-24 bg-ivory" data-testid="about-page">
      <section className="relative h-[70vh] overflow-hidden">
        {siteLoading || !settings.home.editorial.image ? <div className="absolute inset-0 bg-muted animate-pulse" /> : <img src={settings.home.editorial.image} alt="Barique atelier" className="absolute inset-0 w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative h-full container-lux flex flex-col justify-end pb-16 text-ivory">
          <p className="overline text-ivory/70">The House</p>
          <h1 className="mt-4 font-serif tracking-tighter font-light text-5xl md:text-8xl leading-[0.95] max-w-4xl">Crafted Through Heritage.<br/><em className="not-italic">Designed For Today.</em></h1>
        </div>
      </section>

      <section className="py-24 md:py-32 container-lux grid md:grid-cols-3 gap-14">
        <p className="overline text-muted-foreground md:col-span-1">Our Story</p>
        <div className="md:col-span-2 space-y-6 text-lg leading-relaxed max-w-2xl">
          <p>BARIQUE is a contemporary Indian couture house based in New Delhi, creating handcrafted lehengas, sarees, gowns, corsets, bridal couture, occasion wear and menswear.</p>
          <p>Each creation celebrates Indian craftsmanship through a modern design language inspired by architecture, artistry and timeless elegance.</p>
          <p className="text-muted-foreground">Our atelier is a house of karigars — hand-embroiderers, corsetieres, drapers and finishers — who together produce fewer than three hundred pieces a year.</p>
        </div>
      </section>

      <section className="grid md:grid-cols-3 gap-1">
        {[
          ["Aari","Threadwork technique passed down through generations."],
          ["Zardozi","Metal-thread embroidery on velvet and silk."],
          ["Corsetry","Structured bodices, hand-boned in our atelier."],
        ].map(([t, s], i) => (
          <div key={t} className="relative aspect-[4/5] overflow-hidden group">
            {siteLoading || productsLoading || !liveImages[i] ? <div className="w-full h-full bg-muted animate-pulse" /> : <img src={liveImages[i]} alt={t} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-8 left-8 text-ivory max-w-xs">
              <p className="font-serif text-3xl tracking-tight">{t}</p>
              <p className="text-sm text-ivory/80 mt-2">{s}</p>
            </div>
          </div>
        ))}
      </section>

      <section className="py-24 md:py-32 container-lux text-center max-w-3xl">
        <p className="overline text-muted-foreground">Visit The Atelier</p>
        <h2 className="mt-4 font-serif font-light tracking-tighter text-4xl md:text-6xl">Mehrauli, New Delhi</h2>
        <p className="mt-6 text-muted-foreground">By appointment only. Our couture atelier welcomes brides and clientele for private fittings.</p>
        <div className="mt-10 flex justify-center gap-4 flex-wrap">
          <a href="mailto:bariquecouture@gmail.com" className="lux-btn-dark">Email The Atelier</a>
          <a href="https://wa.me/919667245584" className="lux-btn-outline">WhatsApp</a>
        </div>
      </section>
    </div>
  );
}
